import {Component, OnInit} from '@angular/core';
import {CallLog, CallLogService} from '../call-log.service';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {DialerCall, DialerService} from '../dialer.service';
import {isNullOrUndefined} from 'util';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {UserService} from '../user.service';

@Component({
  selector: 'app-web-dialer',
  templateUrl: './web-dialer.component.html',
  styleUrls: ['./web-dialer.component.css']
})
export class WebDialerComponent implements OnInit {

  callsByUsername: BehaviorSubject<Array<CallLog>> = new BehaviorSubject<Array<CallLog>>([]);

  callRequest = new Subject<string>();

  constructor(private cls: CallLogService, private ds: DialerService, private us: UserService) {
  }

  ngOnInit() {
    this.cls
      .getLastByUserId(this.us.currentUser.getValue().databaseId, 0)
      .subscribe((callLogs) => this.callsByUsername.next(callLogs));
    this.ds.actualCallSubject
      .pairwise()
      .subscribe((calls) => {
        if (!isNullOrUndefined(calls[0])) {
          console.log(`d1:${calls[0].id}|${calls[0].dstNumber.getE164Format()}|${calls[0].state}`);
        }
        if (!isNullOrUndefined(calls[1])) {
          console.log(`d2:${calls[1].id}|${calls[1].dstNumber.getE164Format()}|${calls[1].state}`);
        }
        this.updateCallLog(calls[0], calls[1]).subscribe((callLogs) => this.callsByUsername.next(callLogs));
      });
  }

  handleCallRequestEvent(event: string) {
    this.callRequest.next(event);
  }

  updateCallLog(call1: DialerCall, call2: DialerCall): Observable<Array<CallLog>> {
    if (call1 != null && call2 != null && call2.isFinished()) {
      let since = 0;
      if (!isNullOrUndefined(this.callsByUsername.getValue()[0])) {
        since = this.callsByUsername.getValue()[0].start;
      }
      const result = this.cls
        .getLastByUserId(this.us.currentUser.getValue().databaseId, since)
        .map((callLogs) => {
          // if it is refresh without a start just replace the values
          if (since === 0) {
            return callLogs;
          } else {
            return callLogs.concat(this.callsByUsername.getValue());
          }
        });
      return result;
    } else {
      return Observable.empty();
    }
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/web-dialer/web-dialer.component.ts